import React from "react";
import { connect } from "react-redux";
import { Input, Button } from "antd";
import { SearchOutlined, LogoutOutlined } from '@ant-design/icons';
import { setFilter, signOut } from "../../redux/actions/Auth";

export const HeaderNav = ({ setFilter, signOut }) => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      padding: '10px 16px',
      background: '#fff',
      borderBottom: '1px solid #f0f0f0',
      position: 'sticky',
      top: 0,
      zIndex: 100,
    }}>
      <Input
        prefix={<SearchOutlined style={{ color: '#aaa' }} />}
        placeholder="Buscar paciente, sala, cama..."
        allowClear
        onChange={(e) => setFilter(e.target.value)}
        style={{
          flex: 1,
          borderRadius: 10,
          height: 40,
          fontSize: 14,
        }}
      />
      <Button
        icon={<LogoutOutlined />}
        onClick={signOut}
        style={{
          borderRadius: 10,
          height: 40,
          width: 40,
          flexShrink: 0,
          borderColor: '#e0e0e0',
          color: '#666',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />
    </div>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, { setFilter, signOut })(HeaderNav);
